import React from 'react';
import Layout from '../../Components/Layout';
import { useLanguage } from '../../context/LanguageContext';
import { FaRegWindowClose, FaInfoCircle, FaHotel, FaExchangeAlt, FaUndoAlt, FaRoute, 
         FaExclamationTriangle, FaQuestionCircle, FaPhoneAlt } from 'react-icons/fa';

export default function Cancellation() {
    const { translations } = useLanguage();
    const t = translations.policies?.cancellation || {};

    return (
        <Layout>
            {/* Hero Section */}
            <div className="breadcrumb-bar breadcrumb-bg-01 text-center">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-12">
                            <h2 className="breadcrumb-title mb-2">{t.breadcrumb?.title}</h2>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb justify-content-center mb-0">
                                    <li className="breadcrumb-item"><a href="/"><i className="isax isax-home5"></i> {translations.policies?.breadcrumb?.home}</a></li>
                                    <li className="breadcrumb-item">{translations.policies?.breadcrumb?.pages}</li>
                                    <li className="breadcrumb-item active" aria-current="page">{t.breadcrumb?.title}</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <div className="content">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="policy-content bg-white p-4 rounded shadow-sm">
                                <div className="text-center mb-5">
                                    <div className="d-inline-block p-4 rounded-circle bg-light-200 mb-3">
                                        <FaRegWindowClose className="text-primary" size={40} />
                                    </div>
                                    <h1 className="mb-2">{t.title}</h1>
                                    <p className="text-muted">{t.lastUpdated}</p>
                                    <div className="divider-center mb-4">
                                        <span className="divider-line"></span>
                                    </div>
                                </div>

                                {/* Introduction */}
                                <div className="policy-section mb-5">
                                    <h3 className="mb-3 d-flex align-items-center">
                                        <FaInfoCircle className="text-primary me-2" size={24} />
                                        {t.introduction?.title}
                                    </h3>
                                    <p className="lead">{t.introduction?.content}</p>
                                </div>

                                {/* Hotel Bookings */}
                                <div className="policy-section mb-5 p-4 bg-light-200 rounded">
                                    <div className="d-flex align-items-center mb-4">
                                        <div className="me-3">
                                            <span className="badge rounded-circle bg-primary p-3">
                                                <FaHotel className="text-white" size={24} />
                                            </span>
                                        </div>
                                        <h3 className="mb-0">{t.hotelBookings?.title}</h3>
                                    </div>
                                    
                                    {/* Cancellation Policy */}
                                    <div className="mb-5">
                                        <h4 className="mb-3 d-flex align-items-center">
                                            <FaRegWindowClose className="text-primary me-2" size={20} />
                                            {t.hotelBookings?.cancellation?.title}
                                        </h4>
                                        <p>{t.hotelBookings?.cancellation?.content}</p>
                                        <div className="row mt-4">
                                            {t.hotelBookings?.cancellation?.items?.map((item, index) => (
                                                <div key={index} className="col-md-6 col-lg-3 mb-4">
                                                    <div className="card h-100 border-0 shadow-sm">
                                                        <div className="card-header bg-primary text-white">
                                                            <h5 className="card-title mb-0">{item.title}</h5>
                                                        </div>
                                                        <div className="card-body">
                                                            <p className="card-text">{item.description}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Refund Policy */}
                                    <div className="mb-5">
                                        <h4 className="mb-3 d-flex align-items-center">
                                            <FaUndoAlt className="text-primary me-2" size={20} />
                                            {t.hotelBookings?.refund?.title}
                                        </h4>
                                        <p>{t.hotelBookings?.refund?.content}</p>
                                        <div className="card border-0 shadow-sm">
                                            <div className="card-body">
                                                <ul className="list-group list-group-flush">
                                                    {t.hotelBookings?.refund?.items?.map((item, index) => (
                                                        <li key={index} className="list-group-item bg-transparent border-bottom py-3">
                                                            <div className="d-flex">
                                                                <div className="me-3">
                                                                    <span className="badge rounded-pill bg-primary-soft text-primary">
                                                                        {index + 1}
                                                                    </span>
                                                                </div>
                                                                <div>{item}</div>
                                                            </div>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Amendment Policy */}
                                    <div>
                                        <h4 className="mb-3 d-flex align-items-center">
                                            <FaExchangeAlt className="text-primary me-2" size={20} />
                                            {t.hotelBookings?.amendments?.title}
                                        </h4>
                                        <p>{t.hotelBookings?.amendments?.content}</p>
                                        <div className="card border-0 shadow-sm">
                                            <div className="card-body">
                                                <ul className="list-group list-group-flush">
                                                    {t.hotelBookings?.amendments?.items?.map((item, index) => (
                                                        <li key={index} className="list-group-item bg-transparent border-bottom py-3">
                                                            <div className="d-flex">
                                                                <div className="me-3">
                                                                    <span className="badge rounded-pill bg-primary-soft text-primary">
                                                                        {index + 1}
                                                                    </span>
                                                                </div>
                                                                <div>{item}</div>
                                                            </div>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Tour Bookings */}
                                <div className="policy-section mb-5">
                                    <div className="d-flex align-items-center mb-4">
                                        <div className="me-3">
                                            <span className="badge rounded-circle bg-primary p-3">
                                                <FaRoute className="text-white" size={24} />
                                            </span>
                                        </div>
                                        <h3 className="mb-0">{t.tourBookings?.title}</h3>
                                    </div>
                                    
                                    <div className="row">
                                        {/* Cancellation Policy */}
                                        <div className="col-lg-4 mb-4">
                                            <div className="card h-100 border-0 shadow-sm">
                                                <div className="card-header bg-primary text-white">
                                                    <h4 className="card-title mb-0 d-flex align-items-center">
                                                        <FaRegWindowClose className="me-2" size={18} />
                                                        {t.tourBookings?.cancellation?.title}
                                                    </h4>
                                                </div>
                                                <div className="card-body">
                                                    <p>{t.tourBookings?.cancellation?.content}</p>
                                                    <ul className="list-unstyled mb-0">
                                                        {t.tourBookings?.cancellation?.items?.map((item, index) => (
                                                            <li key={index} className="mb-3 pb-3 border-bottom">
                                                                <div className="d-flex">
                                                                    <div className="me-3">
                                                                        <span className="badge rounded-pill bg-primary-soft text-primary">
                                                                            {index + 1}
                                                                        </span>
                                                                    </div>
                                                                    <div>{item}</div>
                                                                </div>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Refund Policy */}
                                        <div className="col-lg-4 mb-4">
                                            <div className="card h-100 border-0 shadow-sm">
                                                <div className="card-header bg-primary text-white">
                                                    <h4 className="card-title mb-0 d-flex align-items-center">
                                                        <FaUndoAlt className="me-2" size={18} />
                                                        {t.tourBookings?.refund?.title}
                                                    </h4>
                                                </div>
                                                <div className="card-body">
                                                    <p>{t.tourBookings?.refund?.content}</p>
                                                    <ul className="list-unstyled mb-0">
                                                        {t.tourBookings?.refund?.items?.map((item, index) => (
                                                            <li key={index} className="mb-3 pb-3 border-bottom">
                                                                <div className="d-flex">
                                                                    <div className="me-3">
                                                                        <span className="badge rounded-pill bg-primary-soft text-primary">
                                                                            {index + 1}
                                                                        </span>
                                                                    </div>
                                                                    <div>{item}</div>
                                                                </div>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Amendment Policy */}
                                        <div className="col-lg-4 mb-4">
                                            <div className="card h-100 border-0 shadow-sm">
                                                <div className="card-header bg-primary text-white">
                                                    <h4 className="card-title mb-0 d-flex align-items-center">
                                                        <FaExchangeAlt className="me-2" size={18} />
                                                        {t.tourBookings?.amendments?.title}
                                                    </h4>
                                                </div>
                                                <div className="card-body">
                                                    <p>{t.tourBookings?.amendments?.content}</p>
                                                    <ul className="list-unstyled mb-0">
                                                        {t.tourBookings?.amendments?.items?.map((item, index) => (
                                                            <li key={index} className="mb-3 pb-3 border-bottom">
                                                                <div className="d-flex">
                                                                    <div className="me-3">
                                                                        <span className="badge rounded-pill bg-primary-soft text-primary">
                                                                            {index + 1}
                                                                        </span>
                                                                    </div>
                                                                    <div>{item}</div>
                                                                </div>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Force Majeure */}
                                <div className="policy-section mb-5 p-4 bg-light-200 rounded">
                                    <h3 className="mb-3 d-flex align-items-center">
                                        <FaExclamationTriangle className="text-primary me-2" size={24} />
                                        {t.forceMAjeure?.title}
                                    </h3>
                                    <p>{t.forceMAjeure?.content}</p>
                                </div>

                                {/* How to Cancel */}
                                <div className="policy-section mb-5">
                                    <h3 className="mb-3 d-flex align-items-center">
                                        <FaQuestionCircle className="text-primary me-2" size={24} />
                                        {t.howToCancel?.title}
                                    </h3>
                                    <p>{t.howToCancel?.content}</p>
                                    
                                    <div className="card border-0 shadow-sm">
                                        <div className="card-body">
                                            <div className="row">
                                                {t.howToCancel?.items?.map((item, index) => (
                                                    <div key={index} className="col-md-6 mb-3">
                                                        <div className="d-flex">
                                                            <div className="me-3">
                                                                <span className="badge rounded-pill bg-primary text-white">
                                                                    {index + 1}
                                                                </span>
                                                            </div>
                                                            <div>{item}</div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Contact */}
                                <div className="policy-section mb-4">
                                    <div className="card border-0 shadow-sm">
                                        <div className="card-body p-4">
                                            <h3 className="mb-3 d-flex align-items-center">
                                                <FaPhoneAlt className="text-primary me-2" size={24} />
                                                {t.contact?.title}
                                            </h3>
                                            <p>{t.contact?.content}</p>
                                            <div className="contact-info mt-3">
                                                <div className="d-flex align-items-center mb-2">
                                                    <div className="me-3">
                                                        <span className="badge bg-primary-soft text-primary p-2">
                                                            <i className="isax isax-sms5 fs-18"></i>
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <strong>Email:</strong> {t.contact?.email}
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center mb-2">
                                                    <div className="me-3">
                                                        <span className="badge bg-primary-soft text-primary p-2">
                                                            <i className="isax isax-call-calling5 fs-18"></i>
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <strong>Phone:</strong> {t.contact?.phone}
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center">
                                                    <div className="me-3">
                                                        <span className="badge bg-primary-soft text-primary p-2">
                                                            <i className="isax isax-map-15 fs-18"></i>
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <strong>Address:</strong> {t.contact?.address}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
} 